import React, { useState, useEffect } from "react";
import axios from "axios";
import {get} from "../utils/OctoberApiUtils";

const initialEventsState = {
  eventTypes: []
};
export const EventsContext = React.createContext(initialEventsState);

export const EventsProvider =  (props) => {
  const [eventsData, setEventsData] = useState(initialEventsState);

  // get event Types data from db
  useEffect(async () => {
    const result = await get('/api/react/add-event/event-types');
    setEventsData({ eventTypes: result.data });
  }, []);


  return (
    <EventsContext.Provider value={eventsData}>
      {props.children}
    </EventsContext.Provider>
  )
};
